export default __webpack_public_path__ + "static/media/DitherLogoWithText.0bed04eb.svg";